import { useState } from 'react'
import { Dialog } from './Dialog.js'
import { useText } from '../i18n.js'

export function UrlDialog({
  onSubmit,
  onClose,
  initial,
}: {
  onSubmit: (url: string) => void
  onClose: () => void
  /** Gesetzt, wenn eine bestehende Einbettung geändert wird. */
  initial?: string
}): React.ReactElement {
  const t = useText()
  const [value, setValue] = useState(initial ?? 'https://')
  const [error, setError] = useState<string | null>(null)

  function submit(event: React.FormEvent): void {
    event.preventDefault()
    let parsed: URL
    try {
      parsed = new URL(value)
    } catch {
      setError(t('url.incomplete'))
      return
    }
    // Nur https: http-Inhalte würden auf einer TLS-Seite ohnehin blockiert.
    if (parsed.protocol !== 'https:') {
      setError(t('url.httpsOnly'))
      return
    }
    onSubmit(parsed.toString())
  }

  return (
    <Dialog title={initial ? t('url.editTitle') : t('url.addTitle')} onClose={onClose}>
      <form onSubmit={submit}>
        <label className="field">
          <span>{t('url.address')}</span>
          <input
            value={value}
            onChange={(event) => {
              setValue(event.target.value)
              setError(null)
            }}
            placeholder={t('url.placeholder')}
          />
        </label>
        {error && <p className="form-error">{error}</p>}
        <p className="muted small">{t('url.embedHint')}</p>
        <button className="button primary" type="submit">
          {initial ? t('url.confirm') : t('url.insert')}
        </button>
      </form>
    </Dialog>
  )
}
